// Created by: Quang Nguyen
import axios from "axios";
const instance = axios.create({
  baseURL: `http://localhost:5000/ndexio-mvp-alpha/us-central1/api`,
});

export default instance;
